<template>
  <div>
    <div class="pageHeader">
      <div class="pageHeader__main pageHeader__main--blue">
        <h1 class="pageHeader__heading">ご登録完了</h1>
      </div>
    </div>

    <div class="container">
      <main class="main">
        <div class="form">
          <form action="">
            <div class="form__header">
            </div>
            <div>
              <h2 class="form__finished">
                お問い合わせありがとうございます。<br>
                追って、病院事務職求人.com事務局より<br class="is-sp">ご連絡させていただきます。
              </h2>
              <div v-if="isCurrentUser" class="form__finishAfter">
                <a href="/inquiry_displays" class="btn btn--large btn--navy">
                  <span class="btn__text">応募履歴を見る</span>
                </a>
              </div>
            </div>

            <p class="form__after">
              <span v-if="shownNewYearHolidayNotice">
                ■　年末年始休業のお知らせ　■<br/>
                【休業期間】<br/>
                {{holidayStartDate}}～{{ holidayEndDate }}
                <br/>
                <br/>
                新年は{{businessStartMonthDay}}より営業開始となります。<br/>
                休業中にいただいたお問合せにつきましては、<br/>
                {{businessStartDate}}以降に対応させていただきます。<br/>
                <br/>
                期間中は何かとご迷惑をおかけし恐縮ではございますが、<br/>
                何卒ご理解を賜りますよう宜しくお願い申し上げます。<br/>
                <br/>
              </span>
              あなたのメールアドレスに「送信内容の確認メール」をお送りいたしました。ご確認ください。<br>
              1週間以上経過しても連絡がない場合は、病院事務職求人.com事務局<br class="is-pc"> （<a href="mailto:m3c-jimucho@m3career.com">m3c-jimucho@m3career.com</a>）にご連絡ください。
            </p>
          </form>
        </div>

        <section class="flow">
          <h2 class="flow__heading">
            転職支援サービスの流れ
          </h2>
          <div class="flow__contents">
            <ul class="flow__list">
              <li class="flow__item">
                <p class="flow__number">STEP 1</p>
                <div class="flow__img">
                  <img :src="assetsImagePath.first_flow_path_pc" class="is-pc" alt="STEP 1">
                  <img :src="assetsImagePath.first_flow_path_sp" class="is-sp" alt="STEP 1">
                </div>
                <p class="flow__text">
                  このサイトから<br class="is-pc">求人内容について<br class="is-pc">問い合わせる
                </p>
              </li>
              <li class="flow__item">
                <p class="flow__number">STEP 2</p>
                <div>
                  <div class="flow__img">
                    <img :src="assetsImagePath.second_flow_path_pc" class="is-pc" alt="STEP2">
                    <img :src="assetsImagePath.second_flow_path_sp" class="is-sp" alt="STEP2">
                  </div>
                  <p class="flow__text">
                    コンサルタントが<br class="is-pc">希望条件をヒアリング<br>
                    求人のご案内
                  </p>
                </div>
              </li>
              <li class="flow__item">
                <p class="flow__number">STEP 3</p>
                <div class="flow__img">
                  <img :src="assetsImagePath.third_flow_path_pc" class="is-pc" alt="STEP3">
                  <img :src="assetsImagePath.third_flow_path_sp" class="is-sp" alt="STEP3">
                </div>
                <p class="flow__text">
                  書類選考・面接
                </p>
              </li>
              <li class="flow__item">
                <p class="flow__number">STEP 4</p>
                <div class="flow__img">
                  <img :src="assetsImagePath.forth_flow_path_pc" class="is-pc" alt="STEP4">
                  <img :src="assetsImagePath.forth_flow_path_sp" class="is-sp" alt="STEP4">
                </div>
                <p class="flow__text">
                  医療機関からの<br class="is-pc">内定の後、勤務開始
                </p>
              </li>
            </ul>
          </div>
        </section>
      </main>
    </div>
  </div>
</template>
<script>
  import _ from 'lodash'

  export default {
    name: 'InquiryThanks',
    props: ['imagePathInfo', 'orderInfo', 'userStatusInfo'],
    data: function(){
      return {
        assetsImagePath: _.cloneDeep(this.imagePathInfo),
        holidayAnnounceStartDate: "2025-12-26T18:30:00",
        holidayAnnounceEndDate: "2026-01-04T19:00:00",
        holidayStartDate: "2025年12月27日（土）",
        holidayEndDate: "2026年1月4日（日）",
        businessStartDate: "2026年1月5日（月）",
        businessStartMonthDay: "1月5日（月）",
        shownNewYearHolidayNotice: new Date("2025-12-26T18:30:00") <= new Date() && new Date() < new Date("2026-01-04T19:00:00"),
        order: _.cloneDeep(this.orderInfo),
        isCurrentUser: _.cloneDeep(this.userStatusInfo)
      }
    },
    watch: {
      // ブラウザの戻るボタンを押した時の挙動
      '$route' (to, from) {
        if (this.$route.name == 'New') {
          this.$store.commit('setNewCount')
        } else if (this.$route.name == 'Thanks') {
          this.$store.commit('setThanksCount')
        }
      }
    }
  }
</script>
